interface TableSkeletonProps {
  columnCount?: number;
  rowCount?: number;
}

export function TableSkeleton({
  columnCount = 3,
  rowCount = 4,
}: TableSkeletonProps) {
  const safeRowCount = Math.min(rowCount, 6);

  return (
    <div className="my-4 overflow-x-auto">
      {/* Table skeleton */}
      <div className="border border-gray-200 rounded w-full min-w-fit overflow-hidden">
        {/* Header skeleton */}
        <div className="flex bg-gray-100 p-2 gap-2">
          {Array.from({ length: columnCount }, (_, i) => (
            <div
              key={i}
              className="h-4 bg-gray-200 rounded animate-pulse flex-1"
            />
          ))}
        </div>

        {/* Row skeletons */}
        {Array.from({ length: safeRowCount }, (_, i) => (
          <div key={i} className="flex p-2 gap-2 border-t border-gray-200">
            {Array.from({ length: columnCount }, (_, j) => (
              <div
                key={j}
                className="h-4 bg-gray-200 rounded animate-pulse flex-1"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
